import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { withStyles } from "@mui/styles";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Panel from "common/components/Panel";
import Resource from "common/components/Resource";
import Pagination from "common/components/Pagination";

const ListCategories = ({ classes, match, history }) => (
  <Panel title="View Categories">
    <Resource
      name="categories"
      render={(categories, { removeOne, prevPage, nextPage, page }) => (
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Last Updated</TableCell>
              <TableCell>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.length ? (
              categories.map((category) => (
                <TableRow hover key={category.id}>
                  <TableCell>{category.id}</TableCell>
                  <TableCell
                    className={classes.clickable}
                    onClick={() => history.push(`${match.url}/${category.id}`)}
                  >
                    {category.name}
                  </TableCell>
                  <TableCell>
                    {moment(category.updated_at).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>
                    <IconButton>
                      <DeleteIcon onClick={() => removeOne(category.id)} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4}>No additional data found.</TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={4} className={classes.pagination}>
                <Pagination
                  page={page}
                  nextPage={nextPage}
                  prevPage={prevPage}
                  items={categories}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      )}
    />
  </Panel>
);

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  table: {
    minWidth: 700,
  },
  pagination: {
    textAlign: "right",
  },
});

ListCategories.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListCategories);
